import styles from "./dropdown-options-menu.module.css";
import { useState } from "react";
import { UIIconName } from "../ui-icon-drawing/ui-icon-type";
import { UIIcon } from "../ui-icon-drawing/ui-icon";
import { DropdownMenu } from "components/common/dropdown-menu";
import { Alignment } from "components/common/dropdown-menu";

interface DropdownOptionsMenuProps {
  // isVisible: boolean;
  labelTitle?: string;
  labelIconName?: UIIconName;
  labelComponent?: React.ReactNode;
  showChevron?: boolean;
  options: DropdownOptionsMenuItem[];
  alignment?: Alignment;
  onSelectOption: (item: DropdownOptionsMenuItem) => void;
}

export interface DropdownOptionsMenuItem {
  id: string;
  label: string;
  meta?: String;
  iconName?: UIIconName;
}

export const DropdownOptionsMenu = (props: DropdownOptionsMenuProps) => {
  const [isVisible, setIsVisible] = useState(false);

  const handleSelection = (item: DropdownOptionsMenuItem) => {
    setIsVisible(false);
    // Handle the type change logic here
    props.onSelectOption(item);
  };

  const label = props.labelComponent ?? (
    <div className={styles.label}>
      {props.labelIconName && (
        <UIIcon iconName={props.labelIconName} variant="REGULAR" size={20} />
      )}
      <span className={styles.labelText}>{props.labelTitle}</span>
      {(props.showChevron ?? true) && (
        <UIIcon
          iconName={isVisible ? "CHEVRON-UP" : "CHEVRON-DOWN"}
          variant="REGULAR"
          size={20}
        />
      )}
    </div>
  );
  return (
    <DropdownMenu
      label={label}
      alignment={props.alignment ?? "center"}
      isVisible={isVisible}
      onToggleVisibility={() => {
        setIsVisible((prev) => !prev);
      }}
    >
      <div className={styles.content}>
        {props.options.map((item) => (
          <button
            key={item.id}
            className={styles.typeDropdownItem}
            onClick={() => handleSelection(item)}
          >
            {item.iconName && (
              <UIIcon iconName={item.iconName} variant="REGULAR" size={20} />
            )}
            <div className={styles.textContent}>
              <h3 className={styles.itemLabel}>{item.label}</h3>
              {item.meta && <p className={styles.metaText}>{item.meta}</p>}
            </div>
          </button>
        ))}
      </div>
    </DropdownMenu>
  );
};
